/* product card - title fit-to-width */

(function () {
  'use strict';

  var TITLE = '[ref="productTitleLink"] > .text-block';
  var CARD = '.product-card__content, product-card';
  var MIN_SIZE = 1;
  var SAFETY = 0.5;
  var pending = null;

  function collect(root) {
    var found = [];
    if (root.nodeType === 1 && root.matches && root.matches(TITLE)) found.push(root);
    if (root.querySelectorAll) {
      Array.prototype.push.apply(found, root.querySelectorAll(TITLE));
    }
    return found;
  }

  function inset(cs) {
    return (
      parseFloat(cs.paddingLeft) +
      parseFloat(cs.paddingRight) +
      parseFloat(cs.borderLeftWidth) +
      parseFloat(cs.borderRightWidth)
    );
  }

  function availableWidth(el, cs) {
    var parent = el.parentElement;
    while (parent && getComputedStyle(parent).display === 'contents') {
      parent = parent.parentElement;
    }
    if (!parent) return 0;

    var limit = el.closest(CARD);
    if (!limit || !limit.contains(parent)) limit = parent;

    var lcs = getComputedStyle(limit);
    var avail =
      limit.clientWidth - parseFloat(lcs.paddingLeft) - parseFloat(lcs.paddingRight);

    var node = parent;
    while (node && node !== limit) {
      var ncs = getComputedStyle(node);
      if (ncs.display !== 'contents') {
        avail -= inset(ncs) + parseFloat(ncs.marginLeft) + parseFloat(ncs.marginRight);
      }
      node = node.parentElement;
    }

    var max = parseFloat(cs.maxWidth);
    if (!isNaN(max)) {
      if (cs.maxWidth.slice(-1) === '%') max = (avail * max) / 100;
      if (max < avail) avail = max;
    }

    return avail - inset(cs) - SAFETY;
  }

  function textWidth(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    return range.getBoundingClientRect().width;
  }

  function shrink(job) {
    if (!(job.width > job.avail)) return false;

    job.size = Math.max(MIN_SIZE, (job.size * job.avail) / job.width - 0.05);
    job.el.style.fontSize = job.size + 'px';
    return true;
  }

  function fit(els) {
    if (!els.length) return;

    var jobs = els.map(function (el) {
      el.style.fontSize = '';
      el.style.lineHeight = '';
      return { el: el };
    });

    jobs.forEach(function (job) {
      var cs = getComputedStyle(job.el);
      job.size = parseFloat(cs.fontSize);
      job.lineHeight = parseFloat(cs.lineHeight);
      job.avail = availableWidth(job.el, cs);
      job.width = textWidth(job.el);
    });

    jobs = jobs.filter(function (job) {
      if (!job.size || !(job.avail > 0)) return false;
      if (job.lineHeight) job.el.style.lineHeight = job.lineHeight + 'px';
      job.el.dataset.ygTitleFit = '';
      return shrink(job);
    });

    jobs.forEach(function (job) {
      job.width = textWidth(job.el);
    });

    jobs.forEach(shrink);
  }

  function fitAll() {
    pending = null;
    fit(collect(document));
  }

  function schedule() {
    if (pending) return;
    pending = setTimeout(fitAll, 100);
  }

  function watch() {
    if (!window.MutationObserver) return;

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && collect(added[j]).length) return schedule();
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  fitAll();
  watch();

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
})();
